import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import './ChangePasswordForm.css';

import { 
    changeConfirmingChangePassword,
    changeConfirmNewPassword, 
    changeCurrentPassword, 
    changeNewPassword, 
    changeNewPasswordsMatch, 
    checkFailedToUpdatePassword, 
    checkNewPasswordsMatch,
    passwordUpdating, 
    selectConfirmingPasswordUpdate, 
    selectConfirmNewPassword, 
    selectCurrentPassword, 
    selectNewPassword, 
    selectUpdatePasswordResult, 
    updatePassword 
} from "./changePasswordFormSlice";

import Sidebar from "../../components/sidebar/Sidebar";
import ConfirmAction from "../../components/confirmAction/ConfirmAction";
import { selectUser } from "../home/userSlice";
import { selectToken } from "../login/loginSlice";

export default function ChangePasswordForm() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const token = useSelector(selectToken);

    const currentPassword = useSelector(selectCurrentPassword);
    const newPassword = useSelector(selectNewPassword);
    const confirmNewPassword = useSelector(selectConfirmNewPassword);
    const newPasswordsMatch = useSelector(checkNewPasswordsMatch);
    const updatingPassword = useSelector(passwordUpdating);
    const failedToUpdatePassword = useSelector(checkFailedToUpdatePassword);
    const updatePasswordResult = useSelector(selectUpdatePasswordResult);
    const confirmingPasswordUpdate = useSelector(selectConfirmingPasswordUpdate);

    const userInfo = useSelector(selectUser);
    const username = userInfo.username;

    useEffect(() => {
        if (newPassword === confirmNewPassword) {
            dispatch(changeNewPasswordsMatch(true));
        } else {
            dispatch(changeNewPasswordsMatch(false));
        }
    }, [newPassword, confirmNewPassword, dispatch])

    useEffect(() => {
        if (updatePasswordResult === "Password updated!") {
            navigate('/settings');
        }
    })

    const handleCurrentPasswordChange = (event) => {
        dispatch(changeCurrentPassword(event.target.value));
    }

    const handleNewPasswordChange = (event) => {
        dispatch(changeNewPassword(event.target.value));
    }

    const handleConfirmNewPasswordChange = (event) => {
        dispatch(changeConfirmNewPassword(event.target.value));
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        dispatch(changeConfirmingChangePassword(true));
        
    }

    const handleConfirmCancelClick = () => {
        dispatch(changeConfirmingChangePassword(false));
    }

    const handleConfirmUpdateClick = () => {
        console.log(username);
        dispatch(updatePassword({username: username, currentPassword: currentPassword, newPassword: newPassword, token}));
        dispatch(changeConfirmingChangePassword(false));
    }

    return (
        <main>
            <Sidebar />
            <section className="change-password-form">
                <h2>Change Password</h2>
                <form onSubmit={handleSubmit}>
                    <label htmlFor="currentPassword">
                        Current Password:
                        <input name="currentPassword" type="password" value={currentPassword} onChange={handleCurrentPasswordChange}></input>
                    </label>
                    <label htmlFor="newPassword">
                        New Password:
                        <input name="newPassword" type="password" value={newPassword} onChange={handleNewPasswordChange}></input>
                    </label>
                    <label htmlFor="confirmNewPassword">
                        Confirm New Password:
                        <input name="confirmNewPassword" type="password" value={confirmNewPassword} onChange={handleConfirmNewPasswordChange}></input>
                    </label>
                    {newPasswordsMatch ? "" : <p className="error">New passwords do not match.</p>}
                    <div className="button-container">
                        <Link to={`../settings`}><button disabled={updatingPassword}>Cancel</button></Link>
                        <button type="submit" disabled={!newPasswordsMatch || updatingPassword}>{updatingPassword ? "Updating Password..." : "Update Password"}</button>
                    </div>
                    {updatePasswordResult !== "Password updated!" && updatePasswordResult ? <p className="error">{updatePasswordResult}</p> : ""}
                    {failedToUpdatePassword ? <p className="error">Failed to update password.</p> : ""}
                </form>
                {confirmingPasswordUpdate ? <ConfirmAction handleConfirm={handleConfirmUpdateClick} handleCancel={handleConfirmCancelClick}/> : ""}
            </section>
        </main>
    )
} 